import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";
import { KEYWORDS } from "@/data/site";

const ARTICLES = [
  {
    q: "Di mana membeli triplek dan multiplek dengan harga distributor?",
    a: "PT. SINAR AL MUBAROKAH adalah distributor triplek murah dan supplier blockboard multiplek terpercaya. Kami menyediakan harga triplek 18mm murah untuk kebutuhan bekisting hingga interior, termasuk distributor triplek phenolic murah untuk proyek cor bertingkat dan distributor multiplek melamin untuk kitchen set premium.",
  },
  {
    q: "Kayu solid apa saja yang tersedia untuk proyek bangunan?",
    a: "Kami jual kayu meranti berkualitas hasil oven presisi, melayani grosir kayu jati jakarta dan jual papan kayu jati perhutani grade A. Tersedia juga grosir balok kayu bangkirai untuk struktur berat, distributor kayu mahoni oven untuk furnitur ekspor, jual papan kayu kampar, serta jual kayu sengon grosir yang ekonomis untuk bekisting dan peti kemas.",
  },
  {
    q: "Apakah melayani kebutuhan triplek cor dan kayu konstruksi proyek?",
    a: "Ya. Sebagai supplier kayu olahan proyek bangunan, kami jual triplek cor coring murah yang kuat menahan beban adukan semen, dan melayani grosir kayu konstruksi proyek dalam volume besar dengan pengiriman terjadwal ke seluruh Indonesia — langsung dari pabrik kayu olahan indonesia milik kami.",
  },
  {
    q: "Produk papan olahan dan finishing apa saja yang tersedia?",
    a: "Kami adalah distributor kayu MDF jakarta dengan density tinggi untuk ukiran CNC dan mebel modern, distributor kayu lapis indonesia serbaguna untuk plafon dan sekat ruangan, serta supplier kayu veneer premium oak dan walnut untuk finishing mewah. Lengkapi detail interior Anda dengan grosir kayu lis kayu profil jati dan meranti molded presisi.",
  },
];

const AccordionItem = ({ item, open, onToggle, index }) => (
  <div className="card-surface overflow-hidden rounded-2xl" data-testid={`seo-accordion-${index}`}>
    <button
      onClick={onToggle}
      data-testid={`seo-accordion-toggle-${index}`}
      className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
    >
      <span className="font-serif text-lg font-semibold text-brand-ink sm:text-xl">{item.q}</span>
      <ChevronDown
        size={20}
        className={`shrink-0 transition-transform duration-300 ${open ? "rotate-180" : ""}`}
        style={{ color: "var(--t-accent)" }}
      />
    </button>
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="px-6 pb-6 text-sm leading-relaxed text-brand-muted">{item.a}</p>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

export const SeoSection = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="panduan" data-testid="seo-section" className="surface py-24 lg:py-32">
      <div className="mx-auto max-w-5xl px-6 lg:px-8">
        <SectionHead
          overline="Panduan Pembeli"
          title={<>Pertanyaan Seputar <span className="italic accent-text">Kayu & Triplek</span></>}
          sub="Semua yang perlu Anda ketahui sebelum membeli material kayu — dijawab langsung oleh tim ahli kami."
        />
        <div className="space-y-4">
          {ARTICLES.map((item, i) => (
            <Reveal key={item.q} delay={i * 0.06}>
              <AccordionItem item={item} index={i} open={open === i} onToggle={() => setOpen(open === i ? -1 : i)} />
            </Reveal>
          ))}
        </div>
        <Reveal className="mt-14">
          <p className="overline-label mb-5 text-center">Kata Kunci Populer</p>
          <div className="flex flex-wrap justify-center gap-2.5" data-testid="keyword-cloud">
            {KEYWORDS.map((k) => (
              <span
                key={k}
                className="rounded-full border px-4 py-1.5 text-xs font-medium text-brand-muted"
                style={{ borderColor: "var(--t-border)" }}
              >
                {k}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
